<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">Overview Bisnis Lini Product</p>
          <div class="text--primary">
            <!-- {{ this.SELECTED_MONTH_PERIOD + " - " + this.SELECTED_YEAR_PERIOD + " - " + this.SELECTED_BRANCH}} -->
            <!-- {{ this.VSLS_PERSON_TYPE }}-->
            <v-row>
              <v-col md="3" sm="12">
                <v-select
                  color="red darken-1"
                  v-model="SLSPERSONTYPE"
                  item-text="SLS_PERSON_TYPE"
                  item-value="SLS_PERSON_TYPE"
                  :items="VSLS_PERSON_TYPE"
                  label="SLS_PERSON_TYPE"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col md="3" sm="12">
                <v-select
                  color="red darken-1"
                  v-model="BISNISGROUP"
                  item-text="BISNIS_GROUP"
                  item-value="BISNIS_GROUP"
                  :items="VBISNIS_GROUP"
                  label="BISNIS_GROUP"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col md="3" sm="12">
                <v-select
                  color="red darken-1"
                  v-model="SCHGROUP"
                  item-text="SCH_GROUP"
                  item-value="SCH_GROUP"
                  :items="VSCH_GROUP"
                  label="SCH_GROUP"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col md="3" sm="12">
                <v-select
                  color="red darken-1"
                  v-model="TARGETLEVEL"
                  item-text="TARGET_LEVEL"
                  item-value="TARGET_LEVEL"
                  :items="VTARGET_LEVEL"
                  label="TARGET_LEVEL"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col class="text-right" md="12">
                <v-btn small color="warning" @click="getOverview()"
                  >Search Overview</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
      <!---->
      <v-card class="mx-auto mt-3" v-show="isShowData">
        <v-card-text>
          <div class="text--primary">
            <v-row>
              <v-col md="6" sm="6"> </v-col>
              <v-col md="6" sm="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col md="12">
                <v-data-table
                  :headers="dtHeaders"
                  :items="dtItems"
                  :search="search"
                  :loading="dtLoading"
                  loading-text="Fetching Data..."
                ></v-data-table>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";

// const ;

export default {
  components: {
    Main,
  },
  data() {
    return {
      dtHeaders: [
        {
          text: "SLS_PERSON_TYPE_ID",
          value: "SLS_PERSON_TYPE_ID",
        },
        {
          text: "SLS_PERSON_TYPE",
          value: "SLS_PERSON_TYPE",
        },
        {
          text: "PRINCIPAL_LINE",
          value: "PRINCIPAL_LINE",
        },
        {
          text: "BISNIS_GROUP",
          value: "BISNIS_GROUP",
        },
        {
          text: "SCH_GROUP",
          value: "SCH_GROUP",
        },
        {
          text: "TARGET_LEVEL",
          value: "TARGET_LEVEL",
        },
        {
          text: "DOT_FLAG",
          value: "DOT_FLAG",
        },
        {
          text: "START_DATE",
          value: "START_DATE",
        },
        {
          text: "END_DATE",
          value: "END_DATE",
        },
        {
          text: "STATUS",
          value: "STATUS",
        },
      ],
      dtItems: [],
      VSLS_PERSON_TYPE: [
        {
          SLS_PERSON_TYPE: "NONE",
        },
      ],
      VBISNIS_GROUP: [
        {
          BISNIS_GROUP: "NONE",
        },
      ],
      VSCH_GROUP: [
        {
          SCH_GROUP: "NONE",
        },
      ],
      VTARGET_LEVEL: [
        {
          TARGET_LEVEL: "NONE",
        },
      ],
      SLSPERSONTYPE: "NONE",
      BISNISGROUP: "NONE",
      SCHGROUP: "NONE",
      TARGETLEVEL: "NONE",
      search: "",
      dtLoading: false,
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isShowData: false,
    };
  },
  mounted() {
    this.prepareData();
  },
  methods: {
    prepareData() {
      this.dtLoading = true;
      this.$http
        .get("/mapping-bisnis-lini-product/filter", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.dtLoading = false;
          const data = res.data.data;
          console.log(data);
          this.VSLS_PERSON_TYPE = data.SLS_PERSON_TYPE;
          this.VBISNIS_GROUP = data.BISNIS_GROUP;
          this.VSCH_GROUP = data.SCH_GROUP;
          this.VTARGET_LEVEL = data.TARGET_LEVEL;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    getOverview() {
      let data = {
        SLSPERSONTYPE: this.SLSPERSONTYPE,
        BISNISGROUP: this.BISNISGROUP,
        SCHGROUP: this.SCHGROUP,
        TARGETLEVEL: this.TARGETLEVEL,
      };

      this.isLoading = true;
      this.$http
        .post("/mapping-bisnis-lini-product/overview", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          console.log(res);
          const { success, message, data } = res.data;
          if (success) {
            this.isLoading = false;
            this.isShowData = true;

            data.forEach((obj, index) => {
              data[index].START_DATE = moment(data[index].START_DATE).format(
                "DD MMM YYYY"
              );
              data[index].END_DATE = moment(data[index].END_DATE).format(
                "DD MMM YYYY"
              );
            });

            this.dtItems = data;
            this.showSnackbar("Get Data Success...");
          } else {
            this.isLoading = false;
            this.isShowData = false;
            this.showSnackbar(message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.isShowData = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
